//Kilimambogo Projects 
import image from "../images/athi/athi1.jpg";
import img1 from '../images/katani/katani1.jpeg';
import img2 from '../images/katani/katani2.jpeg';
import img3 from '../images/katani/katani3.jpeg';

//Juja Projects
import juja1 from '../images/juja/juja1.jpg';
import juja2 from '../images/juja/juja2.jpg';
import juja3 from '../images/juja/juja3.jpeg';
import juja4 from '../images/juja/juja4.jpg';
import juja5 from '../images/juja/juja5.jpg';
import juja6 from '../images/juja/juja6.jpeg';

//Matuu Projects
import matuu1 from '../images/matuu/matuu1.jpeg';
import matuu2 from '../images/matuu/matuu2.jpeg';
import matuu3 from '../images/matuu/matuu3.jpeg';  
import matuu4 from '../images/matuu/matuu4.jpeg';
import matuu5 from '../images/matuu/matuu5.jpeg';
import matuu6 from '../images/matuu/matuu6.jpeg';

//Joska Projects
import joska1 from '../images/joska/joska1.jpg';
import joska2 from '../images/joska/joska2.jpg';
import joska3 from '../images/joska/joska3.jpeg';  
import joska4 from '../images/joska/joska4.jpeg';
import joska5 from '../images/joska/joska5.jpeg';

//Malindi Projects
import malindi1 from '../images/malindi/malindi1.jpeg';
import malindi2 from '../images/malindi/malindi2.jpeg';
import malindi3 from '../images/malindi/malindi3.jpeg';  
import malindi4 from '../images/malindi/malindi4.jpeg';
import malindi5 from '../images/malindi/malindi5.jpeg';
import malindi6 from '../images/malindi/malindi6.jpeg';


//Kithyoko Projects
import kithyoko1 from '../images/kithyoko/kithyoko1.jpeg';
import kithyoko2 from '../images/kithyoko/kithyoko2.jpeg';
import kithyoko3 from '../images/kithyoko/kithyoko3.jpeg';  
import kithyoko4 from '../images/kithyoko/kithyoko4.jpeg';
import kithyoko5 from '../images/kithyoko/kithyoko5.jpeg';
import kithyoko6 from '../images/kithyoko/kithyoko6.jpeg';

//Kamakis Projects
import zuriKamakis1 from '../images/kamakis/kamakis-1.jpeg';
import zuriKamakis2 from '../images/kamakis/kamakis-2.jpeg';
import zuriKamakis3 from '../images/kamakis/kamakis-3.jpeg';
import zuriKamakis4 from '../images/kamakis/kamakis-4.jpeg';
import zuriKamakis5 from '../images/kamakis/kamakis-5.jpeg';
import zuriKamakis6 from '../images/kamakis/kamakis-5.jpeg';


export const projects = [
    {
        id: 1,
        imageUrl1: image,
        imageUrl2: img2,
        imageUrl3: img3,
        imageUrl4: img1,
        imageUrl5: img2,
        imageUrl6: img3,
        featuredImg: img1,
        title: 'Amazon Courts – Katani',
        descriptionTitle : 'Invest in Amazon Courts – Katani!',
        youtubeUrl: '',
        paragraph1: 'Amazon Courts Katani is a premium residential land investment located in one of Nairobi’s most strategic and fast-growing suburbs. Just 2 km from Utawala town and a short drive from Jomo Kenyatta International Airport and Nairobi CBD, this development is ideal for homeowners and investors seeking convenience, connectivity, and long-term value. Designed as a controlled residential community with on-site utilities, Amazon Courts Katani offers the perfect balance between urban access and serene living.',
        whyTitle: 'Why Choose Amazon Courts?',
        reasons: [
            'Prime Location: Only 2 km from Utawala town, placing you close to essential amenities and services.',
            'Unmatched Accessibility: Just 5 minutes to JKIA and 15 minutes to Nairobi CBD.',
            'Controlled Residential Development: Well-planned neighbourhood ensuring order, security, and value appreciation.',
            'Ready Infrastructure: Water and electricity available on site for immediate development.',
            'Ideal Plot Size: Spacious 50 by 100 plots suitable for modern residential homes.',
            'Flexible Pricing Options: Cash price at Ksh 1.65 million or installment plan at Ksh 1.8 million with deposits starting from Ksh 400,000 and balance payable over 12 months.',
        ],
        pricingTitle : 'Pricing & Payment Options',
        pricing: 'KES 1,800,000 Installment or Cash KES 1,650,000 per 1/8 acre plot with flexible payment plans to fit your budget and investment goals.',
        siteVisit: 'Daily Site Visits',
        siteVisitDetails: 'See the potential for yourself! Schedule a site visit to explore your future land. Book your slot today and experience the landscape firsthand',
        price: 'Ksh 1,650,000',
        size: '1/8th Acre',
        propertyType: 'Land',
        landArea: '50X100 SqFt',
        location: 'Katani',
        propertyStatus: 'Available',
        status: 'Available',
        type : 'Featured',
        propertyFeatures: [
            'Ready Title Deeds',
            'Water Supply',
            'Electricity Supply',
            'Fertile Land',
            'Good Road Access',
            'Proximity to Amenities',
            'Serene Environment',
        ],
    },
    {
        id: 2,
        imageUrl1: matuu1,
        imageUrl2: matuu2,
        imageUrl3: matuu3,
        imageUrl4: matuu4,
        imageUrl5: matuu5,
        imageUrl6: matuu6,
        featuredImg: matuu1,
        title: 'Zuri Gardens – Matuu',
        descriptionTitle : 'Invest in Zuri Gardens – Matuu!',
        youtubeUrl: '',
        paragraph1: 'Escape the city and invest in prime, affordable plots at Zuri Gardens, a secure and gated community just 10 minutes from Matuu Town. Perfect for residential development, these plots offer a tranquil environment with essential amenities like well-done access roads and a secure perimeter fence. Enjoy the convenience of a strategic location near the Kivandini-Masinga Bypass and Musingini Sports Resort.',
        whyTitle: 'Why Choose Zuri Gardens - Matuu?',
        reasons: [
            'Prime Location:  Well done access roads.',
            'Prime Location: Ten minutes from Matuu Town.',
            'Utilities in Place: Fully equipped with water and electricity connections, making it easy to start building your dream home or venture',
            'Fertile Land: The rich, arable soil is perfect for gardening and farming enthusiasts.',
            'Convenient Access to Essentials: Proximity to essential services, including schools, hospitals, and shopping centers.',
            'Year-Round Pleasant Climate: Enjoy a serene environment with favorable weather all year, perfect for relaxation and productivity',
            'Enhanced Accessibility: A new bypass is under construction from Tala to Garissa Road, making the location even more accessible.',
            'Nearby Attractions: Just minutes from Musingini Sports Resort, offering endless exploration opportunities',
        ],
        pricingTitle : 'Pricing & Payment Options',
        pricing: 'KES 220,000 Cash Price Or Installment of KES 260,000 per 1/8 acre plot with flexible payment plans to fit your budget and investment goals.. Deposit Ksh 50,000 to secure your plot today.',
        siteVisit: 'Daily Site Visits',
        siteVisitDetails: 'See the potential for yourself! Schedule a site visit to explore your future land. Book your slot today and experience the landscape firsthand',
        price: 'Ksh 220,000',
        size: '1/8th Acre',
        propertyType: 'Land',
        landArea: '50X100 SqFt',
        location: 'Matuu',
        propertyStatus: 'Available',
        status: 'Available',
        type : 'Featured',
        propertyFeatures: [
            'Ready Title Deeds',
            'Water Supply',
            'Electricity Supply',
            'Fertile Land',
            'Good Road Access',
            'Proximity to Amenities',
            'Serene Environment',
        ],
    },
    {
        id: 3,
        imageUrl1: juja1,
        imageUrl2: juja2,
        imageUrl3: juja3,
        imageUrl4: juja4,
        imageUrl5: juja5,
        imageUrl6: juja6,
        featuredImg: juja3,
        title: 'Zuri Gardens Phase 2 – Juja Farm, Athi',
        descriptionTitle : 'Zuri Gardens Juja Phase 2 – Juja Farm, Athi!',
        youtubeUrl: '',
        paragraph1: 'Welcome to Zuri Gardens Phase 2, the latest chapter in our commitment to delivering exceptional living experiences in one of Nairobi’s most promising corridors. Building on the resounding success of Phase 1, this new phase offers a rare opportunity to secure a piece of prime land in a community that is already flourishing. If you are looking for the perfect balance between affordable investment, modern convenience, and a peaceful neighborhood, your search ends here.',
        whyTitle: 'Why Choose Zuri Gardens - Juja?',
        reasons: [
            'Essential Utilities On-Site: Water and electricity are already connected, allowing you to commence your building project without delay',
            'Prime Location: Fifteen minutes from Thika superhighway .',
            'Security and Access: The entire estate is gated and fenced, ensuring privacy and security for you and your family.',
            'We have constructed good, all-weather access roads within the estate for your convenience.',
            'A Thriving Community: This is not a speculative venture; it’s a well-established neighbourhood. With immediate neighbours and a well-developed surroundings, you are investing in a vibrant community, not an isolated plot.',
        ],
        pricingTitle : 'Pricing & Payment Options',
        pricing: 'KES 750,000 per 40 * 90 acre or Cash Price of KES 690,000 plot with flexible payment plans to fit your budget and investment goals. Deposit KES 150,000 to secure your plot today.',
        siteVisit: 'Daily Site Visits',
        siteVisitDetails: 'See the potential for yourself! Schedule a site visit to explore your future land. Book your slot today and experience the landscape firsthand',
        price: 'Ksh 690,000',
        size: '40 * 90',
        propertyType: 'Land',
        landArea: '40X90 SqFt',
        location: 'Juja',
        propertyStatus: 'Available',
        status: 'Available',
        type : 'Featured',
        propertyFeatures: [
            'Ready Title Deeds',
            'Water Supply',
            'Electricity Supply',
            'Good Road Access',
            'Proximity to Amenities',
            'Serene Environment',
        ],
    },
    {
        id: 4,
        imageUrl1: joska1,
        imageUrl2: joska2,
        imageUrl3: joska3,
        imageUrl4: joska4,
        imageUrl5: joska5,
        imageUrl6: joska2,
        featuredImg: joska1,
        title: 'Zuri Gardens – Joska',
        descriptionTitle : 'Invest in Zuri Gardens – Joska!',
        youtubeUrl: 'https://www.youtube.com/watch?v=aKLNb02Xh80',
        paragraph1: 'Zuri Gardens Joska offers an exceptional opportunity to invest in a fast-growing real estate corridor just outside Nairobi. Located only 45 minutes from Nairobi CBD and minutes from Kangundo Road, this development combines strategic location, modern infrastructure, and flexible payment options. With ready title deeds, on-site utilities, and a well-planned neighbourhood, Zuri Gardens Joska is ideal for both immediate development and long-term capital appreciation.',
        whyTitle: 'Why Choose Zuri Gardens - Joska?',
        reasons: [
            'Strategic Location: Only 45 minutes from Nairobi CBD and 10 minutes from the Kangundo Road dual carriage highway, ensuring excellent connectivity.',
            'Affordable Entry: Own a 50 by 100 plot with a low deposit of Ksh 100,000 and flexible payment options.',
            'Ready Infrastructure: Water and electricity available on site, with well-developed access roads.',
            'Immediate Development: Suitable for residential development within a growing and secure neighbourhood.',
            'Secure Ownership: Ready title deeds guarantee a safe and seamless ownership process.',
            'High Growth Potential: Located in a rapidly developing area with strong prospects for value appreciation.',
        ],
        pricingTitle : 'Pricing & Payment Options',
        pricing: 'Cash offer at Ksh 645,000 or a 6-month installment plan at Ksh 750,000. Deposit Ksh 100,000 to secure your plot today.',
        siteVisit: 'Daily Site Visits',
        siteVisitDetails: 'See the potential for yourself! Schedule a site visit to explore your future land. Book your slot today and experience the landscape firsthand',
        price: 'Ksh 645,000',
        size: '1/8th Acre',
        propertyType: 'Land',
        landArea: '50X100 SqFt',
        location: 'Joska',
        propertyStatus: 'Available',
        status: 'Available',
        type : 'Featured',
        propertyFeatures: [
            'Ready Title Deeds',
            'Water Supply',
            'Electricity Supply',
            'Fertile Land',
            'Good Road Access',
            'Proximity to Amenities',
            'Serene Environment',
        ],
    },
        {
        id: 5,
        imageUrl1: malindi1,
        imageUrl2: malindi2,
        imageUrl3: malindi3,
        imageUrl4: malindi4,
        imageUrl5: malindi5,
        imageUrl6: malindi6,
        featuredImg: malindi1,
        title: 'Zuri Gardens Malindi – Phase 4',
        descriptionTitle : 'Invest in Zuri Gardens Malindi – Phase 4!',
        youtubeUrl: 'https://www.youtube.com/watch?v=aKLNb02Xh80',
        paragraph1: 'Zuri Gardens Malindi – Phase 4 presents a unique opportunity to invest in affordable land within a rapidly growing development zone along the Kenyan coast. Strategically located just 45 minutes from Malindi town and close to key landmarks such as Weru Technical College and Globeleq Solar Company, this project is ideal for agribusiness and long-term investment. With proximity to major infrastructure and flexible pricing options, Zuri Gardens Malindi offers an accessible entry point into a high-potential location poised for growth.',
        whyTitle: 'Why Choose Zuri Gardens Malindi – Phase 4?',
        reasons: [
            'Prime Location: Situated only 45 minutes from Malindi town and near major institutions and commercial developments.',
            'Excellent Accessibility: Just 500 metres from the Salagate Bypass, ensuring easy access and future connectivity.',
            'Agribusiness Friendly: Fertile land ideal for farming, agribusiness projects, or land banking.',
            'Affordable Pricing: Cash offer at only Ksh 85,000, making it one of the most accessible investments in the region',
            'Flexible Payment Plan: Installment option at Ksh 120,000 with a low deposit of Ksh 15,000 and balance payable within 6 months.',
            'High Growth Potential: Located in an emerging area with increasing demand and strong prospects for value appreciation.',
        ],
        pricingTitle : 'Pricing & Payment Options',
        pricing: 'Cash offer at Ksh 85,000 or a 6-month installment plan at Ksh 120,000. Deposit Ksh 15,000 to secure your plot today.',
        siteVisit: 'Monthly Site Visits',
        siteVisitDetails: 'See the potential for yourself! Schedule a site visit to explore your future land. Book your slot today and experience the landscape firsthand',
        price: 'Ksh 85,000',
        size: '1/8th Acre',
        propertyType: 'Land',
        landArea: '50X100 SqFt',
        location: 'Malindi',
        propertyStatus: 'Available',
        status: 'Available',
        type : 'Featured',
        propertyFeatures: [
            'Ready Title Deeds',
            'Water Supply',
            'Electricity Supply',
            'Fertile Land',
            'Good Road Access',
            'Proximity to Amenities',
            'Serene Environment',
        ],
    },
        {
        id: 6,
        imageUrl1: kithyoko1,
        imageUrl2: kithyoko2,
        imageUrl3: kithyoko3,
        imageUrl4: kithyoko4,
        imageUrl5: kithyoko5,
        imageUrl6: kithyoko6,
        featuredImg: kithyoko6,
        title: 'Kithyoko Haven Phase 1 - Kithyoko',
        descriptionTitle : 'Kithyoko Haven Phase 1 - Kithyoko!',
        youtubeUrl: 'https://www.youtube.com/watch?v=aKLNb02Xh80',
        paragraph1: 'Kithyoko Haven – Phase 1 offers an affordable and strategic land investment opportunity in a fast-developing area just outside Matuu town. Located at Kithyoko–Maiyuni and only 1.5 km from the Thika–Garissa Highway, this project provides excellent accessibility while maintaining a serene, investment-friendly environment. With flat, fertile land and nearby utilities, Kithyoko Haven is ideal for immediate development or long-term land banking.',
        whyTitle: 'Why Choose Kithyoko Haven?',
        reasons: [
            'Convenient Location: Just 20 minutes from Matuu town and strategically positioned at Kithyoko–Maiyuni.',
            'Excellent Access: Only 1.5 km from the Thika–Garissa Highway, ensuring easy connectivity.',
            'Ready for Development: Flat, fertile land within a well-developing neighbourhood.',
            'Essential Utilities Nearby: Water and electricity available within close proximity.',
            'Affordable & Flexible Pricing: Limited-time cash offer at Ksh 99,000 or an installment plan at Ksh 145,000 with a deposit of Ksh 40,000 and balance payable over 6 months.',
        ],
        pricingTitle : 'Pricing & Payment Options',
        pricing: 'Cash offer at Ksh 99,000 or a 6-month installment plan at Ksh 145,000. Deposit Ksh 40,000 to secure your plot today.',
        siteVisit: 'Daily Site Visits',
        siteVisitDetails: 'See the potential for yourself! Schedule a site visit to explore your future land. Book your slot today and experience the landscape firsthand',
        price: 'Ksh 99,000',
        size: '1/8th Acre',
        propertyType: 'Land',
        landArea: '50X100 SqFt',
        location: 'Kithyoko',
        propertyStatus: 'Available',
        status: 'Available',
        type : 'Featured',
        propertyFeatures: [
            'Ready Title Deeds',
            'Water Supply',
            'Electricity Supply',
            'Fertile Land',
            'Good Road Access',
            'Proximity to Amenities',
            'Serene Environment',
        ],
    },
    {
        id: 7,
        imageUrl1: zuriKamakis1,
        imageUrl2: zuriKamakis2,
        imageUrl3: zuriKamakis3,
        imageUrl4: zuriKamakis4,
        imageUrl5: zuriKamakis5,
        imageUrl6: zuriKamakis6,
        featuredImg: zuriKamakis1,
        title: 'Zuri Paradise – Kamakis',
        descriptionTitle: 'Invest in Zuri Paradise – Kamakis!',
        youtubeUrl: '',
        paragraph1: 'Zuri Paradise Kamakis is a premium residential land investment strategically positioned just 15 minutes from Kamakis and directly along the Great Eastern Bypass. Located 7 km from the main tarmac road, this development offers the perfect balance between accessibility and tranquility. With ready water and electricity on-site, spacious 40×90 plots, and ready individual title deeds, Zuri Paradise Kamakis presents an exceptional opportunity for homeowners and investors seeking quality land with immediate development potential. The proximity to the Great Eastern Bypass ensures excellent connectivity to Nairobi CBD, Thika, and other major towns while maintaining a serene residential environment.',
        paragraph2: 'Zuri Paradise Kamakis offers exceptional value with flexible payment options designed to suit every investor. At just Ksh 999,000 for cash payment or Ksh 1.1 Million on installment, this is an affordable entry point into premium real estate. The installment plan requires a deposit of only Ksh 150,000 with the balance payable over 6 months, making homeownership more accessible than ever. Every plot comes with ready individual title deeds, eliminating lengthy bureaucratic processes and ensuring a smooth, secure transaction. The property is fully serviced with essential utilities including water and electricity already on-site, enabling immediate development.',
        whyTitle: 'Why Choose Zuri Paradise Kamakis?',
        reasons: [
            'Strategic Location: Only 15 minutes from Kamakis and directly along the Great Eastern Bypass for excellent connectivity.',
            'Exceptional Value: Cash price at Ksh 999,000 or installment at Ksh 1.1M – highly competitive pricing.',
            'Flexible Payment Plan: Deposit just Ksh 150,000 with balance payable over 6 months – no interest hassles.',
            'Ready Utilities: Water and electricity already on-site for immediate building and development.',
            'Spacious Plots: Generous 40×100 plot sizes providing ample space for quality residential homes.',
            'Ready Title Deeds: Individual title deeds included – streamlined ownership and secured investment.',
            'Proximity to Amenities: Close to schools, shopping centers, and essential services.',
            'Strong Investment Potential: Located along a major highway corridor with high future appreciation prospects.',
        ],
        pricingTitle: 'Pricing & Payment Options',
        pricing: 'KES 999,000 Cash or KES 1,100,000 Installment per 40×100 plot with flexible payment plans. Deposit KES 150,000 and pay balance over 6 months.',
        siteVisit: 'Daily Site Visits',
        siteVisitDetails: 'See the potential for yourself! Schedule a site visit to explore your future land investment. Book your slot today and experience the landscape and community firsthand.',
        price: 'Ksh 999,000',
        size: '40×100',
        propertyType: 'Land',
        landArea: '40×100 SqFt',
        location: 'Kamakis',
        propertyStatus: 'Available',
        status: 'Available',
        type: 'Featured',
        propertyFeatures: [
            'Ready Individual Title Deeds',
            'Water Supply On-Site',
            'Electricity Supply On-Site',
            'Wide Access Roads',
            'Great Eastern Bypass Proximity',
            'Fertile Land',
            'Serene Environment',
            'Security Fencing',
        ],
    },
];